<template>
    <div class="dia_container dia_conf_edit">
        <div class="cl title">
        </div>
        <div class="edit-content">
            <div class="group-container">
                <el-transfer v-model="group" :titles="['待选资源组', '已选资源组']" :props="transferProps" :data="groupList"></el-transfer>
                <div class="dia_btn_container">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import {errorMessage} from '../../util'
    export default {
        props: ['config', 'completeResourceList', 'curPackage'],
        data: function(){
            return {
                resourceList: [],
                group: [],
                groupList: [],
                transferProps: {
                    key: 'resourcegroupid',
                    label: 'resourcegroupname'
                }
            }
        },
        created: function(){
            this.initGroupList(() => {
                this.group = this.getGroup(this.config)
            })
            this.updateResourceList(this.completeResourceList)
        },
        methods: {
            postUpdatePackage(){
                this.$http.post('/resourceconfig/servicepackage/update',{
                    servicepackageid: this.curPackage.servicepackageid,
                    servicepackagename: this.curPackage.servicepackagename,
                    memo: this.curPackage.memo,
                    resources: this.getResources()
                }).then(function(res){
                    this.$message.success('保存成功！')
                    this.cancel()
                    this.$emit('refresh')
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            updateResourceList(data){
                let list = []
                data.forEach(item => {
                    let temp = {}
                    for(let i in item) {
                        temp[i] = item[i] ? item[i] : ''
                    }
                    list.push(temp)
                })
                this.resourceList = list
            },
            save(){
                let _this = this
                let oldGroup = this.getGroup(this.resourceList)
                let groupClassified = this.classify(oldGroup, this.group)
                let reservedResource = this.getReservedResource(groupClassified.reserved)
                let count = 0
                let newly = groupClassified.newlyAdded
                if(newly.length > 0){
                    newly.forEach(item => {
                        this.postResource(item, data => {
                            reservedResource = reservedResource.concat(data)
                            count++
                            if(newly.length === count) {
                                _this.resourceList = reservedResource
                                _this.postUpdatePackage()
                            }
                        })
                    })
                } else {
                    this.resourceList = reservedResource
                    _this.postUpdatePackage()
                }
            },
            /*
            * @desc 对传入的初始已选择资源组数组和当前已选择资源组数组进行分析，返回保留的资源组数据及新选择资源组数据
            * @param {Array} oldGroup 初始已选择资源组数组
            * @param {Array} curGroup 当前已选择资源组数组
            * @return {Object} 分析结果，ret.reserved--保留的资源组, ret.newlyAdded--新选择的资源组
            */
            classify(oldGroup, curGroup){
                let ret = {
                    reserved: [],
                    newlyAdded: []
                }
                let isReserved = id => {
                    let ret = false
                    oldGroup.forEach(item => {
                        if (item === id) ret = true
                    })
                    return ret
                }
                curGroup.forEach(item => {
                    if (isReserved(item)) {
                        ret.reserved.push(item)
                    } else {
                        ret.newlyAdded.push(item)
                    }
                })
                return ret
            },
            getReservedResource(group){
                let ret = []
                if(group.length > 0){
                    let isReserved = id => {
                        let ret = false
                        group.forEach(item => {
                            if (item === id) ret = true
                        })
                        return ret
                    }
                    this.resourceList.forEach(item => {
                        if(isReserved(item.resourcegroupid)){
                            let temp = {}
                            for(let i in item) {
                                temp[i] = item[i] ? item[i] : ''
                            }
                            ret.push(temp)
                        }
                    })
                }
                return ret
            },
            postResource(code, callback){
                this.$http.post(`/resourceconfig/resource/list`,{
                    resourcegroupid: code,
                    resourcetype: ''
                }).then(function(res){
                    let resourceList = this.parseResource(res.data.resp_data)
                    callback(resourceList)
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            parseResource(data){
                if(data && data.length && data.length > 0) {
                    data.forEach(item => {
                        item.conf = ''
                    })
                } else {
                    data = []
                }
                return data
            },
            initGroupList(callback){
                this.$http.post(`/resourceconfig/resourcegroup/list`,{}).then(function(res){
                    this.groupList = res.data.resp_data
                    if(typeof callback === 'function') callback()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            getGroup(data){
                let ret = []
                let tempObj = {}
                data.forEach(item => {
                    let groupId = item.resourcegroupid
                    if(!tempObj[groupId]) {
                        tempObj[groupId] = true
                        ret.push(groupId)
                    }
                })
                return ret
            },
            getResources(){
                let ret = []
                this.resourceList.forEach(item => {
                    let temp = {
                        resourceid: item.resourceid,
                        conf: item.conf
                    }
                    ret.push(temp)
                })
                return ret
            },
            cancel(){
                this.$emit('cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// configGroup.vue?21425d98